





































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
@Component({
    name:'contractStatus'
})
export default class ContractStatus extends AbpBase  {
    initData:any ={
        searchData: {},
        tableData: {
            title: [
                {
                    title: '项目编号',
                    key: 'projectCode',
                    align: 'center',
                    width: 150
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    align: 'center',
                    render: (h:any,params:any) => {
                        return h('a',{
                            on:{
                                click: ()=> {
                                    this.ToDetail(params.row);
                                }
                            }
                        },params.row.projectName)
                    }
                },
                {
                    title: '经费下达文号',
                    key: 'fundIssuingNumber',
                    align: 'center',
                    width: 150
                },
                {
                    title: '年度下达经费',
                    key: 'annualFund',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.annualFund ? params.row.annualFund+'万元' : '')
                        ])
                    }
                },
                {
                    title: '合同经费',
                    key: 'contractFund',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.contractFund ? params.row.contractFund+'万元' : '')
                        ])
                    }
                },
                {
                    title: '已拨付经费',
                    key: 'appropriatedFund',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.appropriatedFund ? params.row.appropriatedFund+'万元' : '')
                        ])
                    }
                },
                {
                    title: '合同剩余金额',
                    key: 'contractSurplusAmount',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.contractSurplusAmount ? params.row.contractSurplusAmount+'万元' : '')
                        ])
                    }
                },
            ],
            conttent: [],
            totalCount: 0,
            loading: true
        },
        dicData: {
            allDictionary: {},
            bearerOrg: []
        }
    }
    //详情
    ToDetail(e:any) {
        (this as any).reloadComponent('projectDetail');
        this.$nextTick( () => {  
            this.$router.push({
                name: 'projectDetail',
                query: {
                    id: e.id
                }
            })
        } )
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    async GetData() {
        this.initData.tableData.loading = true;
        await Ajax.get('/api/services/app/ProjectManager/GetAllContractExecutionAsync', {params: this.initData.searchData}).then((res:any)=>{
            if(res.data.result){
                this.initData.tableData.content = res.data.result.items;
                this.initData.tableData.totalCount = res.data.result.totalCount;
            }else{
                this.$Message.error('暂无数据！');
                this.initData.tableData.content = [];
                this.initData.tableData.totalCount = 0;
            }
            this.initData.tableData.loading = false;
        })
    }
    async GetDic() {
        if(this.$store.state.project.allDictionary.length == 0){
            await this.$store.dispatch({
                type:'project/GetAllDictionary'
            })
        }   
        if(this.$store.state.project.bearerOrgId.length == 0){
            await this.$store.dispatch({
                type:'project/GetbearerOrg'
            })
        }
        //格式化
        this.$store.state.project.allDictionary.map((item:any) => {
            this.initData.dicData.allDictionary[item.key] = item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            });
        })
        this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgId;
    }
    mounted() {
        this.initData.id = this.$route.query.id;
        this.GetDic();
        this.GetData();
    }
}
